import type { WebModule } from "../../core/modules";
import { GarantiesListPage } from "./routes/liste";
import { GarantieFormPage } from "./routes/formulaire";
import { GarantiePage } from "./routes/fiche";
import { GarantieModelePage } from "./routes/modele";
import { GarantiesWidget } from "./components/garanties-widget";

// Garanties antirouille 10 ans (PROTECTO) : liste, formulaire pré-rempli
// depuis un travail ou un couple client + véhicule, fiche avec cycle de vie
// et document imprimable, modèle de termes (admin), widget d'accueil.
const garanties: WebModule = {
  name: "x-garanties",
  routes: [
    { path: "/garanties", element: <GarantiesListPage /> },
    { path: "/garanties/nouvelle", element: <GarantieFormPage /> },
    { path: "/garanties/modele", element: <GarantieModelePage />, adminOnly: true },
    { path: "/garanties/:id", element: <GarantiePage /> },
    { path: "/garanties/:id/modifier", element: <GarantieFormPage /> },
  ],
  nav: [
    {
      title: "Garanties",
      items: [
        { to: "/garanties", label: "Garanties", icon: "file", end: true },
        { to: "/garanties/modele", label: "Modèle", icon: "edit", end: true, adminOnly: true },
      ],
    },
  ],
  homeWidgets: [{ id: "garanties-stats", element: <GarantiesWidget /> }],
};

export default garanties;
